module.exports = __webpack_public_path__ + "static/wc-stewart-coastal-advisory-group-0f7925cd5f1bb5dc9ab5efa8225a53be.png";